<script setup lang="ts">
import { computed, type PropType, ref, watchEffect } from 'vue'
import type { AdminServiceType } from '@/entities/Cabinet'
import { useModelSwitching } from './../model/model'
import { useHelpers } from '@/shared/lib'
import { useSendSwitching } from './../model/api'

const props = defineProps({
  cabinet: {
    type: Object as PropType<AdminServiceType>,
    required: true,
  },
})

const { data, deleteSwitch, addSwitch } = useModelSwitching()
const { numberList } = useHelpers()
const { sendForm, isPending } = useSendSwitching()

const inputsNum = numberList(26)
const outputsNum = numberList(props.cabinet.contactor_count - 1 || 3)

const valid = ref(false)

/**
 * Функция вычисления свободных контакторов для входов/выходов
 * @param inputs
 * @param type
 */
const getTypeNum = (inputs: number[], type: string) => {
  const propsType = data.value
    .flatMap((item) => item[type])
    .filter((item) => !inputs.includes(item))

  return (type == 'Inputs' ? inputsNum : outputsNum)
    .filter((item) => !propsType.includes(item))
    .map((item) => {
      return {
        value: item,
        title: item + 1,
      }
    })
}

/**
 * Вычисляем деактивацию кнопки
 */
const disabled = computed(() => {
  return outputsNum.length <= data.value.length
})

/* Устанавливаем значение для формы из данных контролера */
watchEffect(() => {
  data.value = [...props.cabinet.switching_logic]
})
</script>

<template>
  <VForm v-model="valid" @submit.prevent="sendForm(data, valid)">
    <div class="form__grid_2">
      <div v-if="data.length">
        <template v-for="(item, index) in data">
          <div class="form__grid_4 mb-6">
            <VSelect
              v-model="item.Inputs"
              :label="$t('itf.inputs')"
              :items="getTypeNum(item.Inputs, 'Inputs')"
              multiple
              hide-details
            />

            <VSelect
              v-model="item.Outputs"
              :label="$t('itf.outputs')"
              :items="getTypeNum(item.Outputs, 'Outputs')"
              multiple
              hide-details
            />

            <VTextField
              :label="$t('itf.retention_time')"
              type="number"
              min="1"
              v-model="item.TimeON"
              hide-details
            />

            <div>
              <VBtn color="error" @click="deleteSwitch(index)">{{ $t('itf.delete') }} </VBtn>
            </div>
          </div>
        </template>
      </div>

      <div class="mt-n4 mb-6" v-else>
        {{ $t('itf.not_switching') }}
      </div>
    </div>

    <div class="form__btn_left">
      <VBtn type="submit" :loading="isPending">{{ $t('itf.save') }}</VBtn>
      <VBtn color="default" variant="tonal" @click="addSwitch" :disabled="disabled">{{
        $t('itf.add')
      }}</VBtn>
    </div>
  </VForm>
</template>
